import React from 'react';

import styles from './styles.module.css';

export default function Deliniator() {
	return <span className={styles.delineator} data-testid="delineator" />;
}
